import { insertOrUpdateBlock } from "@blocknote/core";
import type { DefaultReactSuggestionItem } from "@blocknote/react";
import type { BnEditor } from "blocks-schema";
import { type PersistedTheme, themeCustomButtonBackground, themeCustomButtonText } from "schemas";
import { Icon, iconStyles } from "ui";

export function insertAppointmentLinkBlockItems(editor: BnEditor, theme: PersistedTheme): DefaultReactSuggestionItem[] {
  return [
    {
      title: "Appointment Link",
      onItemClick: () => {
        insertOrUpdateBlock(editor, {
          type: "appointmentLinkBlock",
          props: {
            appointmentId: "",
            buttonBackgroundColor: themeCustomButtonBackground(theme),
            buttonTextColor: themeCustomButtonText(theme),
          },
        });
      },
      aliases: ["appointment", "calendar", "schedule", "meeting"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="Calendar" />,
      subtext: "Link to one of your appointments",
    },
  ];
}
